import { render, staticRenderFns } from "./AttachExisting.vue?vue&type=template&id=2c5012a7&scoped=true&"
import script from "./AttachExisting.vue?vue&type=script&lang=js&"
export * from "./AttachExisting.vue?vue&type=script&lang=js&"
import style0 from "./AttachExisting.vue?vue&type=style&index=0&id=2c5012a7&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c5012a7",
  null
  
)

export default component.exports